import { createSlice, createSelector } from "@reduxjs/toolkit";
import { apiCallBegan } from "./api";
import config from "../../config.json";
import { timeLogApiSlice } from "./timeLogApiSlice";

const slice = createSlice({
  name: "timeLog",
  initialState: {
    list: [],
    loading: false,
    lastFetch: null,
    timeLogDuration: null,
    updateStatus: false,
    timeSheetDelStatus: false,
    tmLogAddedStatus: false,
    timeLogReportStatus: false,
    rateList: [],
    bulkRateList: [],
  },
  reducers: {
    timeLogReceived: (timeLog, action) => {
      timeLog.list = action.payload;
      timeLog.timeSheetDelStatus = false;
      timeLog.updateStatus = false;
      timeLog.tmLogAddedStatus = false;
      timeLog.timeLogReportStatus = false;
    },
    taskDone: (timeLog, action) => {
      timeLog.loading = false;
    },
    ruleAppDataReceived: (timeLog, action) => {
      timeLog.ruleAppData = action.payload;
    },
    timeLogDurationReceived: (timeLog, action) => {
      timeLog.timeLogDuration = action.payload;
      timeLog.timeSheetDelStatus = false;
      timeLog.updateStatus = false;
    },
    projectStartDateUpdating: (timeLog, action) => {
      timeLog.updateStatus = true;
    },
    timeLogTimeSheetDeleted: (timeLog, action) => {
      timeLog.timeSheetDelStatus = action.payload;
    },
    newTimeLogAdedd: (timeLog, action) => {
      timeLog.tmLogAddedStatus = action.payload;
    },
    timeLogReportStatusUpdated: (timeLog, action) => {
      timeLog.timeLogReportStatus = true;
    },
    ratesReceived: (timeLog, action) => {
      timeLog.rateList = action.payload;
    },
    bulkRatesReceived: (timeLog, action) => {
      timeLog.bulkRateList = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(
        timeLogApiSlice.endpoints.loadTimeLogs.matchFulfilled,
        (timeLog, action) => {
          timeLog.list = action.payload;
          timeLog.timeSheetDelStatus = false;
          timeLog.updateStatus = false;
          timeLog.tmLogAddedStatus = false;
          timeLog.timeLogReportStatus = false;
        }
      )
      .addMatcher(
        timeLogApiSlice.endpoints.loadTimeLogDuration.matchFulfilled,
        (timeLog, action) => {
          timeLog.timeLogDuration = action.payload;
          timeLog.timeSheetDelStatus = false;
          timeLog.updateStatus = false;
        }
      )
      .addMatcher(
        timeLogApiSlice.endpoints.loadAllRates.matchFulfilled,
        (timeLog, action) => {
          timeLog.rateList = action.payload;
        }
      )
      .addMatcher(
        timeLogApiSlice.endpoints.updateProjectStartDate.matchFulfilled,
        (timeLog) => {
          timeLog.updateStatus = true;
        }
      )
      .addMatcher(
        timeLogApiSlice.endpoints.deleteTimeSheetDoc.matchFulfilled,
        (timeLog, action) => {
          timeLog.timeSheetDelStatus = action.payload;
        }
      )
      .addMatcher(
        timeLogApiSlice.endpoints.setTimeLogReportStatus.matchFulfilled,
        (timeLog) => {
          timeLog.timeLogReportStatus = true;
        }
      )
      .addMatcher(
        timeLogApiSlice.endpoints.addNewTmLog.matchFulfilled,
        (timeLog, action) => {
          timeLog.tmLogAddedStatus = action.payload;
        }
      )
      .addMatcher(
        timeLogApiSlice.endpoints.loadBulkAllRates.matchFulfilled,
        (timeLog, action) => {
          timeLog.bulkRateList = action.payload;
        }
      );
  },
});

export const {
  timeLogReceived,
  taskDone,
  ruleAppDataReceived,
  timeLogDurationReceived,
  projectStartDateUpdating,
  timeLogTimeSheetDeleted,
  newTimeLogAdedd,
  timeLogReportStatusUpdated,
  ratesReceived,
  bulkRatesReceived,
} = slice.actions;
export default slice.reducer;

export const loadTimeLogs = (id) =>
  apiCallBegan({
    url: config.GetTimeLog + id,
    onSuccess: timeLogReceived.type,
  });

export const addNewTmLog = (data) =>
  apiCallBegan({
    url: config.AddNewTimeLog,
    method: "post",
    data: data,
    onSuccess: newTimeLogAdedd.type,
  });

export const loadTimeLogDuration = (id) =>
  apiCallBegan({
    url: config.GetCandidateProjectStartDate + id,
    onSuccess: timeLogDurationReceived.type,
  });

export const updateProjectStartDate = (id, date) =>
  apiCallBegan({
    url: config.UpdateProjectStartDate + id + "&startDt=" + date,
    onSuccess: projectStartDateUpdating.type,
  });

export const deleteTimeSheetDoc = (id) =>
  apiCallBegan({
    url: config.DeleteTimeLogTimeSheetDoc + id,
    method: "delete",
    onSuccess: timeLogTimeSheetDeleted.type,
  });

export const setTimeLogReportStatus = (id, updatedBy) =>
  apiCallBegan({
    url:
      config.SetTimeLogStatus +
      id +
      (updatedBy ? `?updatedBy=${updatedBy}` : ""),
    method: "put",
    onSuccess: timeLogReportStatusUpdated.type,
  });

export const loadAllRates = (id) =>
  apiCallBegan({
    url: config.GetRateHistory + id,
    onSuccess: ratesReceived.type,
  });

export const loadBulkAllRates = (ids) =>
  apiCallBegan({
    url: config.GetRateHistoryBulk,
    method: "post",
    data: ids,
    onSuccess: bulkRatesReceived.type,
  });

export const getTimeLogs = createSelector(
  (state) => state.entities.timeLog,
  (timeLog) => timeLog.list,
);

export const getTimeLogDuration = createSelector(
  (state) => state.entities.timeLog,
  (timeLog) => timeLog.timeLogDuration,
);

export const getProjectDateUpdateStatus = createSelector(
  (state) => state.entities.timeLog,
  (timeLog) => timeLog.updateStatus,
);

export const getTimeSheetDelStatus = createSelector(
  (state) => state.entities.timeLog,
  (timeLog) => timeLog.timeSheetDelStatus,
);

export const getTmLogAddedStatus = createSelector(
  (state) => state.entities.timeLog,
  (timeLog) => timeLog.tmLogAddedStatus,
);

export const getTimeLogReportStatus = createSelector(
  (state) => state.entities.timeLog,
  (timeLog) => timeLog.timeLogReportStatus,
);

export const getAllRates = createSelector(
  (state) => state.entities.timeLog,
  (timeLog) => timeLog.rateList,
);
export const getBulkAllRates = createSelector(
  (state) => state.entities.timeLog,
  (timeLog) => timeLog.bulkRateList,
);
